import React, { useEffect, useState } from 'react';
import Breadcumb from '../Layouts/Breadcumb';
import axios from 'axios';
import { Constants } from '../endPoints';
import { Container, Typography, Grid, Box, CircularProgress } from '@mui/material';
import Swal from 'sweetalert2';

export default function FAQ() {
  const [faqContent, setFaqContent] = useState(null); // State to store the fetched content
  const [loading, setLoading] = useState(true); // Loading state
  const pageId = 6; // Page ID for FAQ (or pass dynamically)

  // Fetch the FAQ page content
  useEffect(() => {
    const fetchFAQContent = async () => {
      try {
        const response = await axios.get(`${Constants.getPageCmsById}/${pageId}`);
        const description = response.data.data.description;
        
        // Convert HTML to plain text
        const plainText = convertHtmlToText(description);

        setFaqContent(plainText); // Set the content received from the API
        setLoading(false); // Stop loading
      } catch (error) {
        console.error('Error fetching FAQ content:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'Failed to load FAQ content.',
        });
        setLoading(false); // Stop loading on error
      }
    };

    fetchFAQContent();
  }, []); // Empty dependency array means it runs only once when the component is mounted

  // Function to clean HTML content and convert it to plain text
  const convertHtmlToText = (html) => {
    // Create a temporary div to hold the HTML and extract plain text
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || ""; // Extract plain text from the body of the HTML
  };

  if (loading) {
    return (
      <Container style={{ textAlign: 'center', marginTop: '50px' }}>
        <CircularProgress /> {/* Show loading spinner while fetching data */}
      </Container>
    );
  }

  return (
    <>
      <Breadcumb pagetitle="FAQ" />
      <section className="inner_body">
        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h4" component="h1" gutterBottom>
                FAQ
              </Typography>
              {/* Displaying the cleaned text content */}
              <Box sx={{ mt: 2 }} className="terms-content">
                {/* Render the cleaned HTML content */}
                <div
                  dangerouslySetInnerHTML={{ __html: faqContent }}
                  style={{
                    fontFamily: 'Arial, sans-serif',
                    lineHeight: 1.6,
                    fontSize: '16px',
                    color: '#333',
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </section>
    </>
  );
}
